<template>
  <div>
    <div v-for="(value, key) in breakwater" :key="key + 'bp'">
      <l-marker
        :lat-lng="value.latlon"
        :icon="breakwaterIcon"
        :zIndexOffset="550"
        :options="options"
      ></l-marker>
    </div>
    <div v-for="(value, key) in breakwaterLine" :key="key + 'bpline'">
      <l-polyline
        :lat-lngs="value"
        :color="breakwaterLineColor"
        :weight="mapConfig.breakwaterLine.weight"
        :opacity="mapConfig.breakwaterLine.opacity"
        pane="breakwaterLinePane"
      ></l-polyline>
    </div>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import { LMarker, LPolyline } from "vue2-leaflet";
import Marker from "../../../lib/markerSetting.js";
import WebStorage from "../../../lib/webStorage.js";
import MapUtil from "../../../lib/mapUtil.js";
import Color from "../../../scss/color.scss";

/**
 * 川の防災情報 地図画面 破堤点レイヤー
 * BreakwaterLayer.vue
 * @author LIS
 */
export default {
  name: "breakwater-layer",
  components: {
    LMarker,
    LPolyline,
  },
  data() {
    return {
      // 破堤点アイコン
      breakwaterIcon: null,
      // 破堤点ライン色
      breakwaterLineColor: Color.mapBreakwaterLine,
      // マーカーオプション(タブ遷移の抑止)
      options: {
        keyboard: false,
      },
    };
  },
  mounted() {
    // 破堤点アイコン設定
    this.breakwaterIcon = Marker.getIconObj(
      "bw",
      this.mapConfig.markerSetting.bw.size,
      this.mapConfig.markerSetting.bw.anchor
    );
  },
  /** 算出部 */
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** 破堤点情報 */
    breakwater: {
      get() {
        let bpDatas = null;
        if (this.$store.state.map.selectPointIndex == 0) {
          bpDatas = WebStorage.getPoint1Info().bpDatas;
        } else if (this.$store.state.map.selectPointIndex == 1) {
          bpDatas = WebStorage.getPoint2Info().bpDatas;
        } else if (this.$store.state.map.selectPointIndex == 2) {
          bpDatas = WebStorage.getPoint3Info().bpDatas;
        } else if (this.$store.state.map.selectPointIndex == 3) {
          bpDatas = WebStorage.getPoint4Info().bpDatas;
        } else if (this.$store.state.map.selectPointIndex == 4) {
          bpDatas = WebStorage.getPoint5Info().bpDatas;
        }
        if (bpDatas) {
          return bpDatas;
        }
        return [];
      },
    },
    /** 破堤点ライン情報 */
    breakwaterLine: {
      get() {
        if (this.breakwater.length > 0) {
          return MapUtil.getBpLineDatas(
            this.breakwater,
            this.mapConfig.breakPointInterval
          );
        }
        return [];
      },
    },
  },
};
</script>
